export function vLength(min, max = min) {
    return function(value) {
        return !value || !value.length || value.length <= max && value.length >= min
    }
}

export function processNotification(notification) {
    if (notification.text.firstName && notification.text.lastName) {
        return `${notification.text.firstName} ${notification.text.lastName}`
    } else if (notification.text.email) {
        return notification.text.email
    }

    return notification.text.clientId
}

export function notificationIcon(notificationType) {
    const icons = {
        emailConfirmed: 'mail',
        newClient: 'person_add',
        newBusiness: 'person_add'
    }

    return icons[notificationType]
}

export function downloadBlob(data, file) {
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')

    link.href = url
    link.setAttribute('download', file)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item))
}

export function mergeDeep(target, source) {
    const output = Object.assign({}, target)
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (isObject(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, { [key]: source[key] })
                } else {
                    output[key] = mergeDeep(target[key], source[key])
                }
            } else {
                Object.assign(output, { [key]: source[key] })
            }
        })
    }
    return output
}

export function markdown(text) {
    // Regular expressions to extract and clear data
    const boldRegex = /(\*\*|__)(.*?)\1/g
    const linkRegex = /\[([^\[\]]*)\]\(([^)]*)\)/g

    if (text.match(boldRegex)) {
        text = text.replace(boldRegex, `<strong>$2</strong>`)
    }

    if (text.match(linkRegex)) {
        text = text.replace(linkRegex, `<a href="$2" target="_blank">$1</a>`)
    }

    return text
}
